<div class="page" *ngIf="data">
  <app-banner-internal [title]="data.page_title"></app-banner-internal>
  <app-mission-vision-values [data]="dataItem"></app-mission-vision-values>
</div>
